import { Select, SelectItem } from '@heroui/react';

/**
 * Single-value filter dropdown used by every list toolbar. Wraps the design-
 * system Select with the toolbar conventions (small size, empty string =
 * cleared). Previously each toolbar carried its own local `sel()` builder.
 */
export function FilterSelect({ ariaLabel, placeholder, value, onChange, options, className }: {
  ariaLabel: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{ key: string; label: string }>;
  className?: string;
}) {
  return (
    <Select
      aria-label={ariaLabel} size="sm" placeholder={placeholder} className={className}
      selectedKeys={value ? new Set([value]) : new Set()}
      onSelectionChange={(k) => onChange(String(Array.from(k)[0] ?? ''))}
    >
      {options.map((o) => <SelectItem key={o.key}>{o.label}</SelectItem>)}
    </Select>
  );
}
